<ion-grid class="bottom-menu ion-no-padding">
	<ion-row>
		<ion-col (click)="goHome()">
			<ion-icon [ngClass] = "{'active': homeActive()}" class="home"></ion-icon>
			<span class="tab-text">{{'MENU.HOME' | translate}}</span>
		</ion-col>
		<ion-col (click)="goToArchives()" *ngIf="platformType !== 2 && platformType !== 4 && (!!this.auth.hasAccessToPdf() || !!this.auth.hasAccessTo() || !this.auth.isAuthenticated())">
			<ion-icon [ngClass] = "{'active': archivesActive(), 'pdfarchives-highlight': platformType === 0}" class="pdfarchives"></ion-icon>
			<span class="tab-text">PDF</span>
		</ion-col>
		<ion-col (click)="goStaticPage('aide-devoirs')" *ngIf="platformType !== 0">
			<ion-icon [ngClass] = "{'active': concoursActive()}" class="ion-icon-2 devoir"></ion-icon>
			<span class="tab-text">A-Devoirs</span>
		</ion-col>
		<ion-col (click)="goToFavorites()" *ngIf="platformType !== 0 && platformType !== 3 && platformType !== 4">
			<ion-icon class="favoris"></ion-icon>
			<span class="tab-text">Favoris</span>
		</ion-col>
		<ion-col (click)="goToEdit()" *ngIf="platformType !== 0 && !isAuthenticated() && platformType !== 4">
		<ion-icon [ngClass] = "{'active': concoursActive()}" class="compte"></ion-icon>
			<span class="tab-text">{{'MENU.SE_CONNECTER' | translate}}</span>
		</ion-col>
		<ion-col (click)="goToEdit()" *ngIf="platformType !== 0 && isAuthenticated()">
		<ion-icon [ngClass] = "{'active': concoursActive()}" class="compte"></ion-icon>
			<span class="tab-text">{{'MENU.MON_COMPTE' | translate}}</span>
		</ion-col>
		<ion-col (click)="goToExposes()" *ngIf="platformType === 0 && (!!auth.hasAccessTo()  || !!auth.hasAccessToMain())">
			<ion-icon [ngClass] = "{'active': exposesActive()}" class="copy"></ion-icon>
			<span class="tab-text">Exposés</span>
		</ion-col>
		<ion-col (click)="goToExternalArchives()" *ngIf="platformType !== 0">
			<ion-icon class="star"></ion-icon>
			<span class="tab-text">Archives</span>
		</ion-col>
    <ion-col (click)="goToThematicFiles(thematicfilessubcatPage)" *ngIf="platformType === 0 && !general && (!!auth.hasAccessTo() || !!auth.hasAccessToMain())">
			<ion-icon [ngClass] = "{'active': dossiersActive()}" class="dossiers"></ion-icon>
			<span class="tab-text">Dossiers</span>
		</ion-col>
    <ion-col (click)="goToThematicFiles(thematicfilessubcatPage)" *ngIf="platformType === 0 && general && theme && (!!auth.hasAccessTo() || !!auth.hasAccessToMain())">
			<ion-icon [ngClass] = "{'active': dossiersActive()}" class="dossiers"></ion-icon>
			<span class="tab-text">Dossiers</span>
		</ion-col>
		<ion-col (click)="goToMenu()">
			<ion-icon [ngClass] = "{'active': menuActive()}" class="menu"></ion-icon>
			<span class="tab-text">{{'MENU.AUTRE' | translate}}</span>
		</ion-col>
	</ion-row>
</ion-grid>
